import React from 'react';
import { Typography } from '@mui/material';

interface AlertBoxMessageProps {
  children: React.ReactNode;
  enableMarginBottom?: boolean;
}

export const AlertBoxMessage: React.FC<AlertBoxMessageProps> = ({ children, enableMarginBottom = false }) => {
  return (
    <Typography
      variant="body2"
      sx={{
        lineHeight: '20px',
        fontSize: '14px',
        color: '#475467',
        mt: '4px',
        mb: enableMarginBottom ? '10px' : 0,
      }}
    >
      {children}
    </Typography>
  );
};
